import React, { useEffect, useState } from "react";

const API_BASE_URL = "https://dizv6b75kj46r.cloudfront.net";


//this is for local server
//const API_BASE_URL = "http://localhost:5001";

export default function ResetPassword() {
  // states: init|ready|submitting|ok|error
  const [status, setStatus] = useState("init");
  const [msg, setMsg] = useState("");

  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");

  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const e = params.get("email");
    const t = params.get("token");

    if (!e || !t) {
      setStatus("error");
      setMsg("Missing email or token.");
      return;
    }

    setEmail(e);
    setToken(t);
    setStatus("ready");
  }, []);

  async function submit(e) {
    e.preventDefault();

    if (!newPassword.trim()) {
      setStatus("error");
      setMsg("Please enter a new password.");
      return;
    }
    if (newPassword !== confirm) {
      setStatus("error");
      setMsg("Passwords do not match.");
      return;
    }

    setStatus("submitting");
    setMsg("");

    try {
      const res = await fetch(`${API_BASE_URL}/auth/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email,
          token,
          new_password: newPassword,
        }),
      });

      const data = await res.json().catch(() => ({}));

      if (!res.ok) {
        throw new Error(data?.error || "Reset failed.");
      }

      setStatus("ok");
      setMsg(data?.message || "Password updated.");
    } catch (err) {
      setStatus("error");
      setMsg(err.message || "Reset failed.");
    }
  }

  return (
    <div style={{ padding: 40, fontFamily: "Arial", maxWidth: 520 }}>
      {status === "init" && <h2>Loading…</h2>}

      {status === "ready" && (
        <>
          <h2>Reset your password</h2>
          <p style={{ opacity: 0.8, marginTop: 6 }}>
            For: <b>{email}</b>
          </p>

          <form onSubmit={submit} style={{ marginTop: 14 }}>
            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 6, fontWeight: 600 }}>
                New password
              </label>
              <input
                type="password"
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: "1px solid #ccc",
                  fontSize: 16,
                  boxSizing: "border-box",
                }}
                required
              />
            </div>

            <div style={{ marginBottom: 10 }}>
              <label style={{ display: "block", marginBottom: 6, fontWeight: 600 }}>
                Confirm new password
              </label>
              <input
                type="password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                placeholder="••••••••"
                style={{
                  width: "100%",
                  padding: "10px 12px",
                  borderRadius: 8,
                  border: "1px solid #ccc",
                  fontSize: 16,
                  boxSizing: "border-box",
                }}
                required
              />
            </div>

            <button
              type="submit"
              disabled={status === "submitting"}
              style={{
                padding: "10px 14px",
                borderRadius: 10,
                border: "none",
                cursor: status === "submitting" ? "not-allowed" : "pointer",
                fontWeight: 700,
              }}
            >
              {status === "submitting" ? "Updating…" : "Update password"}
            </button>
          </form>
        </>
      )}

      {status === "ok" && <h2>✅ {msg}</h2>}
      {status === "error" && (
        <>
          <h2>❌ {msg}</h2>
          {/* if token expired or invalid, user will need to request again */}
        </>
      )}

      <p style={{ marginTop: 18 }}>
        <a href="/login">Go to login</a>
      </p>
    </div>
  );
}
